// The short Security page at /security, in both languages. The full technical
// account is /security/technical, English only (securityPage.ts). Every claim
// here restates something that page says; change both together.
const securitySummary = {
  header: {
    kicker: "Security",
    title: "How your data is protected",
    leadA:
      "Anyone asked to entrust patient data to an information system is entitled to know how that data is protected. This page gives the short version. The full technical account, written for security reviewers and in English only, is on ",
    leadLink: "the technical page",
    leadB: ".",
  },
  readMore: "Read more",
  // Shown on the English-only technical page to visitors using another language.
  englishOnlyNotice: "This page is only available in English.",
  englishOnlyBackLink: "Back to the summary",
  identities: {
    title: "Identities are replaced, and the keys are kept apart",
    body: "When data enters the system, identifiers such as kennitölur, names and phone numbers are replaced by pseudonyms. Each project has its own key, so pseudonyms from one project are useless in any other. The keys are kept in a separate key-management service, not in the database.",
  },
  access: {
    title: "Seeing a dataset is not the same as being able to read it",
    body: "Who can see that a dataset exists and who can download it are two separate permissions. Downloading requires membership of the dataset's project and either project-wide access, a PI's approval or a share from a PI. The decision is made in one place and checked again every time data leaves the system. Department managers can oversee everything in their department but cannot download research data.",
  },
  encrypted: {
    title: "Stored encrypted, sent encrypted",
    body: "Dataset files and original identifier values are stored encrypted, each dataset under its own key. All traffic to the system is encrypted (TLS), and only that one connection is reachable from outside.",
  },
  login: {
    title: "Who can log in",
    body: "Accounts are created by invitation only, and every account must use two-factor authentication. Repeated failed logins are slowed down, and logins from a new location are recorded.",
  },
  detection: {
    title: "Personal data inside uploads",
    body: "When a file is uploaded, the system looks for personal data, including identifiers hidden inside free text such as a kennitala in a notes column, and shows what it found before anything is stored. This is an aid, not a guarantee: the person uploading makes the decision and should check the file carefully.",
  },
  audit: {
    title: "Everything is recorded",
    body: "Logins, uploads, downloads (who, when and which columns), requests and their decisions, shares, and changes to permissions are recorded in an audit trail that cannot be edited through the system. That record is what lets a project answer an ethics board or a regulator with evidence.",
  },
  retention: {
    title: "Retention and deletion",
    body: "A dataset can be given an expiry date. After it, nobody can download the dataset, and after a short grace period the file and its key are destroyed, so the data cannot be recovered even from backups. The record of who used the dataset is kept.",
  },
  limitations: {
    title: "What the system does not protect against",
    intro: "We list the gaps we know about. The most important ones in plain terms:",
    anonymousStrong: "Pseudonymized data is not anonymous.",
    anonymousRest:
      " A small group with a rare diagnosis can still be identifiable from the data itself. Your duties for the data remain.",
    operatorsStrong: "People who run the servers are trusted.",
    operatorsRest:
      " Someone with full access to the server and the key store could technically read the data. Today this is prevented by procedure, not by a technical control. It is the most important open item.",
    keysStrong: "Project keys cannot be replaced",
    keysRest: " if one is ever compromised.",
    auditStrong: "The audit trail lives in the database.",
    auditRest:
      " It cannot be edited through the system, but it is not yet copied to separate, unalterable storage.",
    fullListA: "The full list is in ",
    fullListLink: "Known limitations",
    fullListB: ".",
  },
  report: {
    title: "Reporting a problem",
    bodyA: "If you think you have found a security problem, write to us at ",
    bodyB:
      ", or tell your department's manager. Please don't test further than needed to show the problem, and don't access or keep anyone else's data. Reports are welcome from anyone, even if you're not sure.",
  },
};

export default securitySummary;
